import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Tue Jan 29 2019
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { jsonConversions, SelloutSettingsConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../../shared/api';
import logger from '../../../shared/logger';
export var SelloutSettingsLayer =
/*#__PURE__*/
function () {
  function SelloutSettingsLayer() {
    _classCallCheck(this, SelloutSettingsLayer);
  }

  _createClass(SelloutSettingsLayer, [{
    key: "findAll",
    value: function findAll() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var endpoint, _ref, data, list;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_SETTINGS);
                _context.next = 4;
                return api(endpoint).get();

              case 4:
                _ref = _context.sent;
                data = _ref.data;
                list = new Map();
                (data.result || []).map(function (s) {
                  return list.set(s.priceListTypeId, _this.converter.toObject(s, jsonConversions));
                });
                return _context.abrupt("return", list);

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                logger.error(_context.t0);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));
    }
  }, {
    key: "update",
    value: function update(selloutSettings) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var endpoint, _ref2, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                endpoint = "".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.SELLOUT_SETTINGS_UPDATE);
                _context2.next = 4;
                return api(endpoint).post({
                  selloutSettings: selloutSettings
                });

              case 4:
                _ref2 = _context2.sent;
                data = _ref2.data;
                return _context2.abrupt("return", this.converter.toObject(data.result, jsonConversions));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                logger.error(_context2.t0);
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));
    }
  }]);

  return SelloutSettingsLayer;
}();

__decorate([Inject, __metadata("design:type", SelloutSettingsConverter)], SelloutSettingsLayer.prototype, "converter", void 0);